const META_SELECTORS = [
    'meta[name="description"]',
    'meta[property="og:url"]',
    'meta[property="og:title"]',
    'meta[property="og:description"]',
    'meta[name="twitter:title"]',
    'meta[name="twitter:description"]',
];

function syncHeadElement(selector, nextDoc) {
    const current = document.head.querySelector(selector);
    const next = nextDoc.head.querySelector(selector);

    if (!next) {
        current?.remove();
        return;
    }

    if (current) {
        [...next.attributes].forEach(({ name, value }) => {
            current.setAttribute(name, value);
        });
        return;
    }

    document.head.appendChild(next.cloneNode(true));
}

function syncHreflangLinks(nextDoc) {
    document.head.querySelectorAll('link[rel="alternate"][hreflang]').forEach((el) => el.remove());

    nextDoc.head.querySelectorAll('link[rel="alternate"][hreflang]').forEach((el) => {
        document.head.appendChild(el.cloneNode(true));
    });
}

function syncJsonLdScripts(nextDoc) {
    document.head.querySelectorAll('script[type="application/ld+json"]').forEach((el) => el.remove());

    nextDoc.head.querySelectorAll('script[type="application/ld+json"]').forEach((el) => {
        document.head.appendChild(el.cloneNode(true));
    });
}

/**
 * Synchronise le <head> après une transition modularload.
 * modularload ne met à jour que title + meta description par défaut.
 */
export function updateDocumentHead(nextDoc) {
    if (!nextDoc?.head) return;

    const title = nextDoc.querySelector('title');
    if (title?.textContent) {
        document.title = title.textContent;
    }

    syncHeadElement('link[rel="canonical"]', nextDoc);
    syncHreflangLinks(nextDoc);
    syncJsonLdScripts(nextDoc);

    META_SELECTORS.forEach((selector) => syncHeadElement(selector, nextDoc));
}
